// extracted by css-extract-rspack-plugin
var _1 = "fEOfr";
export { _1 as "mainModuleStyle" }
